module.exports = __webpack_public_path__ + "img/service-icon1.8327acb0.jpg";